import { useEffect, useState } from 'react';
import httpService from '../../services/httpService';
import { ApiEndpoints } from '../../constants/appConstants';

interface SyncSubmittedDataSectionProps {
  onShowToast: (severity: 'success' | 'info' | 'warn' | 'error', summary: string, detail: string) => void;
}

const SyncSubmittedDataSection = ({
  onShowToast
}: SyncSubmittedDataSectionProps) => {
  const [selectedEventType, setSelectedEventType] = useState<string>('');
  const [selectedEventStatus, setSelectedEventStatus] = useState<string>('');
  const [isSyncing, setIsSyncing] = useState(false);
  const [eventTypes,setEventTypes] = useState([]);
  const [eventStatuses,setEventStatuses] = useState([]);


  useEffect(()=>{
    getAllEvents();
    getAllEventsStatuses();
  },[])
  const handleSyncData = async () => {
    setIsSyncing(true);
    try {
      onShowToast('info', 'Syncing', 'Syncing submitted data. Please wait...');
      await httpService.post(ApiEndpoints.ExeciteEvents, {
        EventTypes: [selectedEventType],
        EventStatuses: [selectedEventStatus]
      });
      onShowToast('success', 'Sync Complete', 'Submitted data synced successfully.');
    } catch (error) {
      onShowToast('error', 'Sync Error', 'Error syncing submitted data. Please try again later.');
      console.error('Error syncing submitted data:', error);
    } finally {
      setIsSyncing(false);
    }
  };

  const getAllEvents = () => {
    httpService.get(`${ApiEndpoints.GetAllEvents}`)
    .then((resp:any)=>{
      if(resp?.status === 200){
         const data = resp?.data.map((x:any)=>x.eventCode);
         setEventTypes(data??[]);
      }
    })
  }

  const getAllEventsStatuses = () => {
    httpService.get(`${ApiEndpoints.GetAllEventStatuses}`)
    .then((resp:any)=>{
      if(resp?.status === 200){
         const data = resp?.data.map((x:any)=>x);
         setEventStatuses(data??[]);
      }
    })
  }

  return (
    <div className='sync-submitted-card'>
      <p className='sync-submitted-hint'>
        <span className='pi pi-info-circle' aria-hidden='true' />
        Select an event type, then click <strong>Sync Data</strong> to synchronise submitted records.
      </p>
      <div className='sync-submitted-form'>
        <div className='admin-field'>
          <label htmlFor='eventType'>Event Type</label>
          <select
            id='eventType'
            value={selectedEventType}
            onChange={(e) => setSelectedEventType(e.target.value)}
            disabled={isSyncing}
          >
            <option key='placeholder' value="">Select Event</option>
            {eventTypes?.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
         <div className='admin-field'>
          <label htmlFor='eventType'>Event Status</label>
          <select
            id='eventType'
            value={selectedEventStatus}
            onChange={(e) => setSelectedEventStatus(e.target.value)}
            disabled={isSyncing}
          >
            <option key='placeholder' value="">Select Status</option>
            {eventStatuses?.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>
        </div>
        <div className='sync-submitted-action'>
          <button
            type='button'
            className='admin-btn admin-btn-primary sync-data-btn'
            onClick={handleSyncData}
            disabled={!selectedEventType || selectedEventType.trim() ===''|| !selectedEventStatus || selectedEventStatus.trim() ===''|| isSyncing}
          >
            {isSyncing ? (
              <><span className='pi pi-spin pi-spinner' aria-hidden='true' /> Syncing...</>
            ) : (
              <><span className='pi pi-refresh' aria-hidden='true' /> Sync Data</>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SyncSubmittedDataSection;
